var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"cardTitle"},[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.title))]),_c('v-card-subtitle',{domProps:{"textContent":_vm._s(_vm.subTitle)}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }